export const formatCurrency = (
  value: number | null | undefined,
  options: {} = { roundingMode: 'ceil', trailingZeroDisplay: 'stripIfInteger' }
) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'narrowSymbol',
    ...options,
  })
    .format(value || 0)
    .replace(/\.[0]+$/, '');
};
